/* eslint-disable */
import Image from 'next/image';
import React, { useEffect, useState } from 'react';

import { useAuth } from '@/api';
import { useLivePrice } from '@/api/digital-gold/livePrice';
import { useDgUserWallet } from '@/api/digital-gold/userWallet';
import type { WalletStore } from '@/store/digital-gold/wallet-store';
import { useWalletStore } from '@/store/digital-gold/wallet-store';

import GoldCoinImage from '../../../assets/images/icons/gold-coin-icon.svg';
import RupeeCoinImage from '../../../assets/images/icons/rupee-icon.svg';
import useMoengageStore from '@/store/moengage';
import { stat } from 'fs';

export const UserDgWallet = (props: {
  note: boolean;
  page?: string | undefined;
}) => {
  const { note, page } = props;
  const { userDetails } = useAuth();

  const { resultData } = useDgUserWallet({
    customerId: userDetails?.id,
  });
  const { livePriceData } = useLivePrice();

  const [updateResponse] = useWalletStore((state: WalletStore) => [
    state.updateResponse,
  ]);
  const [setDgWalletInvoiceBalance,setDgWalletNonInvoiceBalance] = useMoengageStore((state) => [state.setDgWalletInvoiceBalance, state.setDgWalletNonInvoiceBalance])
  const [goldAvailable, setGoldAvailable] = useState<number>(0);

  let availableSaleGold: string = '0';

  useEffect(() => {
    updateResponse(resultData);
    setDgWalletInvoiceBalance(resultData?.goldBalance);
    setDgWalletNonInvoiceBalance(resultData?.nonInvoicedBalance);
    availableSaleGold =
      (livePriceData.saleGoldRate * resultData?.goldBalance).toFixed(2);
    setGoldAvailable(parseFloat(availableSaleGold));
  }, [resultData, livePriceData]);

  const getDeviceView = () => {
    if (page === undefined) {
      return 'loanDetails__card loanCard tablet-margin';
    }
    if (page === 'buy_mobile') {
      return 'loanDetails__card loanCard mobile-view';
    }

    return 'loanDetails__card loanCard tablet-margin web-view';
  };

  return (
    <div className={getDeviceView()}>
      <div className="loanCard__title-withChips">
        <p className="loanCard__title text--bold text--black mb-0">
          My Gold Balance
        </p>
      </div>
      <div className="loanCard__dates verticle-card">
        <div className="left">
          <span className="text--regular text--gray title">
            <Image 
style={{ color: undefined }}
              className="img-fluid mobile-icon"
              src={GoldCoinImage}
              alt="gold coin"
            />
            In Grams
          </span>
          <span className="text--bold text--black price">
            <Image 
style={{ color: undefined }}
              className="img-fluid web-icon"
              src={GoldCoinImage}
              alt="gold coin"
            />{' '}
            {resultData !== undefined
              ? (
                  Number(resultData?.goldBalance) +
                  Number(resultData?.nonInvoicedBalance)
                ).toFixed(4)
              : 0.0}{' '}
            gms
          </span>
        </div>
        <div className="right">
          <span className="text--regular text--gray title">
            <Image 
style={{ color: undefined }}
              className="img-fluid mobile-icon"
              src={RupeeCoinImage}
              alt="rupee icon"
            />{' '}
            Current Value
          </span>
          <span className="text--bold text--black price">
            <Image 
style={{ color: undefined }}
              className="img-fluid web-icon"
              src={RupeeCoinImage}
              alt="rupee icon"
            />{' '}
            ₹
            {resultData !== undefined
              ? (
                  (parseFloat(resultData?.goldBalance.toString()) +
                    parseFloat(resultData?.nonInvoicedBalance.toString())) *
                  livePriceData.saleGoldRate
                ) // Number(resultData?.nonInvoicedBalance) * 10 // Number(resultData?.goldBalance) +
                  .toFixed(2)
              : 0.0}
          </span>
        </div>
      </div>
      {note && (
        <>
          <hr className="mb-2" />
          <p>
            Gold Available for selling :{' '}
            <span className="text--bold text--black price">
              {' '}
              {resultData?.goldBalance}gms ( ₹{goldAvailable})
            </span>
          </p>
         { resultData?.nonInvoicedBalance && Number.parseFloat(resultData?.nonInvoicedBalance) > 0 && <div className="wallet-note mt-2">
            <p className="note_heading">Note:</p>
            <p>
              For security reasons,you can sell {resultData?.nonInvoicedBalance}{' '}
              gms of your gold only after 24 working hours of your purchase
            </p>
          </div> }
        </> 
      )}
    </div>
  );
};
